import { render } from "./FitToggleIcon.svg?vue&type=template&id=4f38d884"
const script = {}
script.render = render

export default script